<template>
  <div class="mv-cartrow" :class="{ 'is-sel': active, 'is-menu': menuOpen }" :title="rowTitle" @click="onClickItem">
    <span class="pill-dot" :style="{ '--pill': state.color }"></span>
    <span class="mv-cartrow-name">{{ value.name }}</span>
    <span class="mono mv-cartrow-meta">{{ subclips.length }}<span v-if="total" class="mv-cartrow-dur"> · {{ total }}</span></span>
    <v-menu v-model="menuOpen" offset-y left content-class="mv-menu">
      <template v-slot:activator="{ on }">
        <button type="button" class="mv-rowbtn mv-cartrow-menu" title="Cart actions" aria-label="Cart actions" v-on="on" @click.stop>
          <v-icon size="16">mdi-dots-horizontal</v-icon>
        </button>
      </template>
      <v-list dense>
        <v-list-item @click="onClickRename">
          <v-list-item-title>Rename…</v-list-item-title>
        </v-list-item>
        <v-list-item @click="onClickRestoreButton">
          <v-list-item-title>Force restore…</v-list-item-title>
        </v-list-item>
        <v-list-item @click="onClickDelete">
          <v-list-item-title>Delete…</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { cartState } from "@/scripts/assetStatus";
import { cartTotals, totalLabel } from "@/scripts/cartTotals.js";
import { plural } from "@/scripts/plural.js";

export default {
  props: {
    value: {},
  },
  data: () => {
    return {
      menuOpen: false,
    };
  },
  computed: {
    active() {
      return this.$store.state.cart.id === this.value.id;
    },
    state() {
      return cartState(this.value);
    },
    subclips() {
      return this.value.subclips || [];
    },
    // Only lengths already known: a row never asks for one.
    total() {
      return totalLabel(cartTotals(this.subclips, this.$store.state.clipLookups()), this.subclips.length);
    },
    rowTitle() {
      return [this.state.label, plural(this.subclips.length, "clip"), this.total].filter(Boolean).join(" · ");
    },
  },
  methods: {
    onClickRestoreButton() {
      this.$store.state.showConfirmDialog('Restore cart "' + this.value.name + '"?', () => this.$store.state.restoreCart(this.value.id));
    },
    onClickRename() {
      this.$store.state.showPromptDialog(`Rename cart "${this.value.name}" to:`, this.value.name, (newName) => {
        if (newName) this.$store.state.renameCart(this.value, newName);
      });
    },
    onClickDelete() {
      this.$store.state.showConfirmDialog('Delete cart "' + this.value.name + '"?', () => this.$store.state.deleteCart(this.value.id));
    },
    onClickItem() {
      this.$store.state.selectCart(this.value);
    },
  },
};
</script>
